import MessageModalStore from "@/stores/MessageModalStore";

const useMessageModal = () => {
  const setIsOpen = MessageModalStore((state) => state.setIsOpen);
  const setMessage = MessageModalStore((state) => state.setMessage);
  const setCallback = MessageModalStore((state) => state.setCallback);

  const showMessageModal = ({ message, callback }: { message: string; callback?: VoidFunction }) => {
    setIsOpen(true);
    setMessage(message);
    setCallback(() => {
      if (callback) {
        callback();
      }
      setIsOpen(false);
    });
  };

  return {
    showMessageModal,
  };
};

export default useMessageModal;
